/* Componente per creare la DataGrid dove andranno a finire i risultati delle query */
import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';


export default function Grid(props) {
  
    var colums = [{
              field: 'id',
              headerName:"N°",
              width: 60,
              
            }]
    try {
      
        props.data.layer.infoField.fields.map(x=>{
            if(x.visible ===true){
            colums.push({field:x.fieldName,headerName: x.fieldLabel,width: 180})}
            return null
        })
        
    } catch (error) {
        
    }
  return (
    <div class='datagrid'>
      <DataGrid 
      pageSize={5}
        columns={colums}
        rows={props.rows}
        
      />
    </div>
  );
}